"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const Loading_1 = require("../icons/Loading/Loading");
const Button_styled_1 = require("./Button.styled");
const themeVariantMap = {
    primary: Button_styled_1.PrimaryButtonStyled,
    secondary: Button_styled_1.SecondaryButtonStyled,
    subtle: Button_styled_1.SubtleButtonStyled,
    text: Button_styled_1.TextButtonStyled,
    solid: Button_styled_1.SolidButtonStyled,
    outlined: Button_styled_1.OutlinedButtonStyled,
    'outlined-dark': Button_styled_1.OutlinedDarkButtonStyled,
    'outlined-white': Button_styled_1.OutlinedWhiteButtonStyled,
    'icon-text': Button_styled_1.IconTextButtonStyled,
};
const renderLoader = (variant) => variant !== 'text' && variant !== 'icon-text' ? react_1.default.createElement(Loading_1.LoadingIcon, null) : react_1.default.createElement(Button_styled_1.TextLoaderStyled, null, "LOADING");
const renderChildren = ({ icon, children }) => {
    const iconOnly = icon !== null && !children;
    if (!icon) {
        return children;
    }
    if (iconOnly) {
        return icon;
    }
    return (react_1.default.createElement(Button_styled_1.ChildrenButtonWithIconContainer, null,
        react_1.default.createElement("span", null, icon),
        react_1.default.createElement("span", null, children)));
};
const Button = (props) => {
    const { variant = 'primary', size = 'medium', isLoading = false, children, onClick, icon = null, blocked = false, dataTestId = '' } = props, restProps = __rest(props, ["variant", "size", "isLoading", "children", "onClick", "icon", "blocked", "dataTestId"]);
    const ButtonComponent = themeVariantMap[variant];
    const iconOnly = icon !== null && !children;
    return (react_1.default.createElement(ButtonComponent, Object.assign({ "data-test": "button", "data-test-id": dataTestId, blocked: blocked, isLoading: isLoading, size: size }, restProps, { iconOnly: iconOnly, onClick: onClick }), isLoading ? renderLoader(variant) : renderChildren(props)));
};
exports.Button = Button;
